"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TakeAPicture_1 = require("./TakeAPicture");
exports.default = TakeAPicture_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TakeAPicture/index.js
// module id = 1275
// module chunks = 8